import DistanceTypeListPage from "./list/index.page";

export const distanceTypePageRouteName = "/config/distance-type";

const DistanceTypePage = () => {
  return <DistanceTypeListPage />;
};

export default DistanceTypePage;
